import type { Tool } from './Tool';
import { Grid } from '../Grid';

export class Mixer implements Tool {
    name = 'mixer';

    apply(x: number, y: number, grid: Grid, size: number): void {
        const mixRadius = size + 2; // 搅拌范围稍大一点
        const mixCount = 5; // 每次搅拌次数

        for (let i = 0; i < mixCount; i++) {
            // 在范围内随机选两个点 (方形范围)
            // 简单起见，Mixer 不使用 BaseBrush 的 applyAt 遍历，而是自己实现随机采样
            // 如果要统一，应该让 Mixer 继承 BaseBrush，但目前的随机采样逻辑可能更适合 Mixer
            // 不过既然用户没有要求改 Mixer，我们只需要确保接口兼容（Mixer 实现了 Tool 接口，不需要改动）
            // 但是 Tool 接口定义是 apply(x, y, grid, size)，Mixer 实现了这个。
            // BaseBrush 也是实现的这个。
            // 所以 Mixer 不需要改动，除非 Mixer 继承了 BaseBrush。
            
            // 检查 Mixer 是否继承 BaseBrush
            // 之前 grep 结果显示 Mixer implements Tool，没有继承 BaseBrush。
            // 所以不需要改动。
            
            const dx1 = Math.floor(Math.random() * (mixRadius * 2 + 1)) - mixRadius;
            const dy1 = Math.floor(Math.random() * (mixRadius * 2 + 1)) - mixRadius;

            const dx2 = Math.floor(Math.random() * (mixRadius * 2 + 1)) - mixRadius;
            const dy2 = Math.floor(Math.random() * (mixRadius * 2 + 1)) - mixRadius;

            const x1 = x + dx1;
            const y1 = y + dy1;
            const x2 = x + dx2;
            const y2 = y + dy2;

            // 确保都在网格内
            if (x1 >= 0 && x1 < grid.width && y1 >= 0 && y1 < grid.height &&
                x2 >= 0 && x2 < grid.width && y2 >= 0 && y2 < grid.height) {
                // 检查是否可搅拌
                const p1 = grid.get(x1, y1);
                const p2 = grid.get(x2, y2);

                const isMixable1 = (!p1 || p1.props.isMixable) && (!p1 || !p1.props.isGlued);
                const isMixable2 = (!p2 || p2.props.isMixable) && (!p2 || !p2.props.isGlued);

                if (isMixable1 && isMixable2) {
                    // 获取索引并交换
                    const idx1 = y1 * grid.width + x1;
                    const idx2 = y2 * grid.width + x2;
                    grid.swap(idx1, idx2);
                }
            }
        }
    }
}
